import { render, staticRenderFns } from "./WorldViewDetail.vue?vue&type=template&id=db93c858&scoped=true&"
import script from "./WorldViewDetail.vue?vue&type=script&lang=ts&"
export * from "./WorldViewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./WorldViewDetail.vue?vue&type=style&index=0&id=db93c858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db93c858",
  null
  
)

export default component.exports